import React from 'react';
import {useTranslation} from "react-i18next";
import helpers from '../../../Utils/helpers'
import {InfoLabel} from "../../Badges/InfoLabel";
import targetGroupHelpers from "../../../Utils/targetGroups";
import {targetGroupConfigurations} from "../../../Constants/VOSS/targetGroups";
import {paymentTerms} from "../../../Constants/paymentTerms";
import {invoiceFees} from "../../../Constants/invoiceFee";
import {
    VossCustomerStatusTranslation
} from "../../../Constants/VOSS/vossCustomerStatus";
import customerRoutes from "../../../Constants/Customer/customerRoutes";

export function InternalInfo({ customer, dropdownlists }) {
    
    const customerGroups = dropdownlists && dropdownlists.CustomerGroup;
    const customerTypes = dropdownlists && dropdownlists.CustomerType;
    const customerStatuses = dropdownlists && dropdownlists.CustomerStatus;
    const customerGroups2 = dropdownlists && dropdownlists.CustomerGroup2;
    const spcsEdi = dropdownlists && dropdownlists.SpcsEdi;
    const vossCustomer = customer?.vossCustomer;
    
    const vbCustomer = customer?.vbCustomer;

    const {t} = useTranslation();

    const getCustomerInvoiceFee = () => {

        let index = invoiceFees.findIndex(item => item.id === vbCustomer.invoiceFee);

        if (index !== -1) {
            return invoiceFees[index].name;
        }

        return vbCustomer.invoiceFee;
    }
    
    function renderField(label, value) {
        return (<>
                <th className="bold">{label}</th>
                <td>{value}</td>
            </>
        )
    }
    
    function getCustomerField(customer, getter) {
        return customer ? getter(customer) : "N/A";
    }
    
    return (<div className="table-responsive">
            <table className="table table-stripe">
                <tbody>
                {vossCustomer?.targetGroups &&
                    <tr>
                        <th className="bold">{t('internalinfocontainer.targetgroup')}</th>
                        <td colSpan={3}>
                            {vossCustomer?.targetGroups?.map((targetGroup) => {
                                return <div key={targetGroup.id}
                                            className="d-inline-block position-relative infolabel pr-8 py-4">
                                    <InfoLabel title={targetGroup.name}/>
                                </div>
                            })}
                        </td>
                    </tr>
                }
                <tr>
                    {renderField(t('internalinfocontainer.customergroup'), getCustomerField(vbCustomer, vb => `${helpers.getDropdownItemName(customerGroups, vb.customerGroup)} / ${vb.customerGroup}`))}
                    {renderField(t('internalinfocontainer.customergroup2'), getCustomerField(vbCustomer, vb => vb.secondaryGroup === 0 ? "-" : `${helpers.getDropdownItemName(customerGroups2, vb.secondaryGroup)} / ${vb.secondaryGroup}`))}
                </tr>
                <tr>
                    {renderField(t('internalinfocontainer.voncustomergroup'), getCustomerField(customer.vossCustomer?.customerGroup, c => `${helpers.getDropdownItemName(customerGroups, customer.vossCustomer?.customerGroup)} / ${customer.vossCustomer?.customerGroup}`))}
                    {renderField(t('internalinfocontainer.customertype'), getCustomerField(vbCustomer,vb => helpers.getDropdownItemName(customerTypes, vb.type)))}
                </tr>
                <tr>
                    {renderField(t('internalinfocontainer.invoicefee'), getCustomerField(vbCustomer, vb => getCustomerInvoiceFee(vb)))}
                    {renderField(t('internalinfocontainer.creditlimit'), getCustomerField(vbCustomer, vb => vb.creditLimit))}
                </tr>
                <tr>
                    {renderField(t("internalinfocontainer.invoicecustomernumber"), getCustomerField(vbCustomer,vb => vb.invoiceCustomerNumber > 0 ?
                        <a className="text-nowrap"
                           onClick={(e) => window.open(customerRoutes.customer(vb.invoiceCustomerNumber), '_blank')}>{vb.invoiceCustomerNumber}</a>
                        : "-"))}
                    {renderField(t('internalinfocontainer.spcsedi'), getCustomerField(vbCustomer,vb => helpers.getDropdownItemName(spcsEdi, vb.spcsEdi) || "-"))}
                </tr>
                <tr>
                    {renderField(t('internalinfocontainer.responsibleperson'), getCustomerField(vbCustomer,vb => vb.responsibleSalesPerson?.salesPersonName || "-"))}
                    {renderField(t('internalinfocontainer.paymentterms'), getCustomerField(vbCustomer,vb => helpers.getDropdownItemName(paymentTerms, vb.paymentTerms)))}
                </tr>
                <tr>
                    {renderField(t('internalinfocontainer.customerstatus'), getCustomerField(vbCustomer,vb => helpers.getDropdownItemName(customerStatuses, vb.status)), customerStatuses)}
                    {vossCustomer && renderField(t('internalinfocontainer.statusvoss'), t(VossCustomerStatusTranslation[vossCustomer.status]) || vossCustomer.status)}
                </tr>
                <tr>
                    {vossCustomer && renderField(t('internalinfocontainer.created'), vossCustomer?.created ? helpers.formatDate(vossCustomer.created) : "-")}
                    {vossCustomer &&
                        <>
                            <th className="bold">{t('maininfocontainer.expirydate')}</th>
                            <td>
                                {vossCustomer.expiryDate ? helpers.formatDate(vossCustomer.expiryDate) : "N/A"}
                            </td>
                        </>
                    }
                </tr>
                </tbody>
            </table>
        </div>
    )
}